import { List, Stack, Typography } from "@mui/material";
import { PrerequisiteItem } from "Components/Hunter/Prerequisites/PrerequisiteItem";
import { PrerequisitesProgress } from "Components/Hunter/Prerequisites/PrerequisitesProgress";
import type { HunterPrerequisitesWidgetProps } from "Components/Hunter/Prerequisites/types";
import { PrerequisiteCompletionStatus } from "Infrastructure/Api/Api";
import { InfoBox } from "Components/Shared/InfoBox/InfoBox";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.Dashboard.Prerequisites;

export const HunterPrerequisitesWidget = ({
  items,
}: HunterPrerequisitesWidgetProps) => {
  const { t } = useResource();

  const isEverythingFinished = items.every(
    ({ completionStatus }) =>
      completionStatus !== PrerequisiteCompletionStatus.NotCompleted,
  );

  return (
    <PrimaryPaper>
      <Stack spacing={2}>
        <Typography variant="h6" fontWeight={600} textTransform="uppercase">
          {t(RESOURCES.Title)}
        </Typography>
        <Typography color="text.secondary">
          {t(RESOURCES.Description)}
        </Typography>
        {isEverythingFinished ? (
          <InfoBox variant="success" content={t(RESOURCES.CompletedMessage)} />
        ) : (
          <>
            <PrerequisitesProgress items={items} />
            <List disablePadding>
              {items.map((item) => (
                <PrerequisiteItem key={item.id} {...item} />
              ))}
            </List>
            <InfoBox variant="warning" content={t(RESOURCES.InfoMessage)} />
          </>
        )}
      </Stack>
    </PrimaryPaper>
  );
};
